<template>
	<div class="content">
		<h2>Select a type of visualization to create</h2>
		<div class="options">
			<div class="type" @click="create('visualization')">
				<font-awesome-icon icon="chart-pie" />
				Chart
			</div>
			<div class="type" @click="create('bigNumber')">
				<font-awesome-icon icon="sort-numeric-down" />
				Big Number
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		methods: {
			create(resource) {
				this.$router.push({ name: `${resource}.create` });
			}
		}
	}
</script>


<style scoped>
	h2 {
		border-bottom: 1px solid #eee;
		margin-bottom: 20px;
		padding-bottom: 20px;
		font-weight: bold;
	}
	.options .type {
		border-bottom: 1px solid #eee;
		padding-bottom: 20px;
		padding-top: 20px;
		padding-left: 20px;
		font-size: 20px;
	}

	.type:hover {
		background-color: #eee;
	}
</style>